import { apiPost } from './apiClient';
import { API_ENDPOINTS } from '../config/api.config';

/**
 * POST /addUser
 * @param {{ email: string, name: string, phoneNumber: string, password: string, roles: string[] }} data
 */
export const addUser = (data) => apiPost(API_ENDPOINTS.ADD_USER, data);

/**
 * POST /getUser
 * @param {{ id: number }} data
 */
export const getUser = (id) => apiPost(API_ENDPOINTS.GET_USER, { id });

/**
 * POST /updateUser
 * @param {{ id: number, name?: string, phoneNumber?: string }} data
 */
export const updateUser = (data) => apiPost(API_ENDPOINTS.UPDATE_USER, data);

/**
 * POST /changePassword
 * @param {{ id: number, name: string, password: string }} data
 */
export const changePassword = (data) => apiPost(API_ENDPOINTS.CHANGE_PASSWORD, data);

/**
 * POST /login
 * @param {{ email: string, password: string }} data
 */
export const login = (data) => apiPost(API_ENDPOINTS.LOGIN, data);

/**
 * Different backends shape the /login response differently (nested under
 * "user", flat on the root, different casing for the id field, token at the
 * root vs nested, etc). This normalizes whatever comes back into a single
 * consistent shape: { id, name, email, phoneNumber, token }.
 *
 * If `id` ends up null here, open the browser console after logging in —
 * the raw response is logged (and available at result.__raw) to help you
 * find the correct field name, which you can then add to the lists below.
 */
export const resolveAuthUser = (result) => {
  if (!result || typeof result !== 'object') return { id: null, token: undefined };

  // Some backends nest the actual user record one level down.
  const nested = result.user || result.userInfo || result.account || result.profile || {};
  const source = { ...result, ...nested };

  const idCandidates = [
    source.id, source.Id, source.ID, source.userId, source.userID,
    source.user_id, source._id, source.customerId, source.customer_id,
  ];
  const id = idCandidates.find((v) => v !== undefined && v !== null) ?? null;

  const token = result.token || result.accessToken || result.access_token || result.authToken;

  return {
    id,
    name: source.name ?? source.fullName ?? source.full_name,
    email: source.email,
    phoneNumber: source.phoneNumber ?? source.phone ?? source.phone_number,
    token,
  };
};
